const isHoverDevice = window.matchMedia('(hover: hover)').matches;

/**
 *
 * This sets aria-expanded to a new value
 *
 * @param {HTMLButtonElement} $el - The HTML Button Element
 * @param {boolean} expanded - The new aria-expanded value
 *
 */
function setAriaExpanded($el, expanded) {
  $el.setAttribute('aria-expanded', String(expanded));
}

/**
 * This toggles aria-expanded value
 *
 * @param {HTMLButtonElement} $el - The HTML Button Element
 *
 */
function toggleAriaExpanded($el) {
  const expanded = $el.getAttribute('aria-expanded') === 'true';

  setAriaExpanded($el, !expanded);
}

document.querySelectorAll('.hover-tile__inner').forEach(($el) => {
  $el.addEventListener('click', () => {
    toggleAriaExpanded($el);
  });

  if (isHoverDevice) {
    $el.addEventListener('mouseenter', () => {
      setAriaExpanded($el, true);
    });

    $el.addEventListener('mouseleave', () => {
      setAriaExpanded($el, false);
    });
  }
});
